import { useEffect, useRef, useState } from 'react';
import { SuperSplat } from '@ad3d/supersplat';
import { useSuperSplatBridge } from '../../hooks/use-supersplat-bridge';
import { ViewToolbar } from './view-toolbar';
import { SceneToolbar } from './scene-toolbar';
import { splatLoaderService } from '@ad3d/services';

export function SuperSplatCanvas() {
    const containerRef = useRef<HTMLDivElement>(null);
    const [editor, setEditor] = useState<any>(null);
    const editorRef = useRef<any>(null);

    useEffect(() => {
        if (!containerRef.current) return;

        // Create a dedicated wrapper for this instance to avoid race conditions
        const wrapper = document.createElement('div');
        wrapper.style.width = '100%';
        wrapper.style.height = '100%';
        wrapper.style.position = 'absolute';
        wrapper.style.top = '0';
        wrapper.style.left = '0';
        containerRef.current.appendChild(wrapper);

        let active = true;

        SuperSplat(wrapper).then((instance) => {
            if (!active) {
                instance.destroy();
                if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
                return;
            }
            editorRef.current = instance;
            setEditor(instance);
            splatLoaderService.setEditor(instance); // Register editor with service
            console.log('SuperSplat initialized', instance);
        }).catch(err => {
            console.error("SuperSplat init failed", err);
            if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
        });

        return () => {
            active = false;
            if (editorRef.current) {
                editorRef.current.destroy();
                editorRef.current = null;
                setEditor(null);
                splatLoaderService.setEditor(null);
            }
            // Always remove the wrapper on cleanup to ensure visual cleanup
            if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
        };
    }, []);

    // Connect the Bridge
    useSuperSplatBridge(editor);

    return (
        <div 
            ref={containerRef} 
            className="w-full h-full relative overflow-hidden"
            style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
            <ViewToolbar />
            <SceneToolbar />
        </div>
    );
}
